/* psi-cart-instant.js */
(function(){
'use strict';
/* v513 — Un solo avviso "Aggiunto al carrello" per tutto il sito.
   Telefono: foglio che sale dal basso. Computer: riquadro in alto a destra sotto la
   testata, come Nike. Tutto lo stile sta qui (anche quello del computer, che prima
   veniva sovrapposto da psi-cart-nike-core-v410.css e psi-scheda-nike.liquid).
   Prima lo script si fermava se nella pagina non c'era il carrello a scomparsa
   (#cart-drawer): per questo la pagina BOX, che ha un layout suo senza carrello,
   usava una notifica diversa. Ora la parte del drawer gira solo se il drawer c'e',
   e l'avviso e' disponibile ovunque tramite window.psiCartConfirm.show(ctx):
     { variantId, title, trigger }            un prodotto
     { group, title, image, meta:[], trigger } un BOX (righe con _psi_box_group)
   piu', facoltativi, cartHref (dove porta "Visualizza carrello") e onClose. */
var drawer=document.getElementById('cart-drawer');
function money(cents){cents=Math.round(cents||0);var neg=cents<0?'-':'',e,c;cents=Math.abs(cents);e=Math.floor(cents/100);c=cents%100;return neg+'€'+String(e).replace(/\B(?=(\d{3})+(?!\d))/g,'.')+','+(c<10?'0'+c:c)}
function closeDrawer(){if(!drawer)return;drawer.setAttribute('aria-hidden','true');drawer.classList.remove('open');var overlay=document.getElementById('cart-overlay');if(overlay)overlay.classList.remove('visible');document.body.classList.remove('cart-open')}
if(drawer){
  var refresh=function(){var total=0;drawer.querySelectorAll('.cart-item:not(.is-removing)').forEach(function(li){var qEl=li.querySelector('.qty-num'),pEl=li.querySelector('.cart-item-price');if(!qEl||!pEl)return;var q=parseInt(qEl.tagName==='INPUT'?qEl.value:qEl.textContent,10)||0,unit=parseInt(pEl.dataset.unitPrice,10)||0;total+=unit*q});var sub=document.getElementById('cart-subtotal');if(sub)sub.textContent=money(total);var bar=drawer.querySelector('.psi-fs-bar');if(!bar)return;var thr=parseInt(bar.dataset.threshold,10)||0;if(thr<=0)return;var fill=bar.querySelector('.psi-fs-fill');if(fill)fill.style.width=Math.min(100,Math.round(total*100/thr))+'%';var txt=bar.querySelector('.psi-fs-text');if(total>=thr){bar.classList.add('psi-fs-done');if(txt)txt.innerHTML='✓ Hai ottenuto la <b>spedizione gratuita</b>'}else{bar.classList.remove('psi-fs-done');if(txt)txt.innerHTML='Ti mancano <b>'+money(thr-total)+'</b> per la <b>spedizione gratuita</b>'}};
  var schedule=function(){requestAnimationFrame(function(){requestAnimationFrame(refresh)})};
  drawer.addEventListener('click',function(e){var t=e.target&&e.target.closest?e.target.closest('.qty-btn,#cart-continue'):null;if(!t)return;if(t.id==='cart-continue'){e.preventDefault();closeDrawer();return}if(t.classList.contains('qty-btn'))schedule()});
  drawer.addEventListener('change',function(e){if(e.target.classList&&e.target.classList.contains('qty-num'))schedule()});
  drawer.addEventListener('keyup',function(e){if(e.key==='Enter'&&e.target.classList&&e.target.classList.contains('qty-num'))schedule()});
}

var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
var pendingAdd=null,pendingTimer=null,previousFocus=null,confirmationRequest=0,currentCtx=null;
var style=document.createElement('style');
style.id='psi-cart-confirm-style';
style.textContent=
'#psi-cart-confirm{position:fixed;inset:0;z-index:2147483647;display:flex;align-items:flex-end;justify-content:center;pointer-events:none;visibility:hidden;font-family:inherit}'+
'#psi-cart-confirm.is-open{pointer-events:auto;visibility:visible}'+
/* v513 — carattere e tagli scritti qui, non ereditati: sulla pagina BOX il
   carattere di base e' Barlow e i titoli sono in maiuscolo, e l'avviso deve
   essere identico ovunque. */
'#psi-cart-confirm,#psi-cart-confirm *{font-family:"Helvetica Neue",Helvetica,Arial,sans-serif;text-transform:none}'+
'#psi-cart-confirm .psi-cart-confirm-title{font-weight:500;letter-spacing:-.024em}'+
'#psi-cart-confirm .psi-cart-confirm-product-title,#psi-cart-confirm .psi-cart-confirm-action,#psi-cart-confirm .psi-cart-confirm-meta,#psi-cart-confirm .psi-cart-confirm-price{letter-spacing:normal}'+
'.psi-cart-confirm-backdrop{position:absolute;inset:0;background:rgba(0,0,0,.34);opacity:0;transition:opacity .22s ease}'+
'#psi-cart-confirm.is-open .psi-cart-confirm-backdrop{opacity:1}'+
'.psi-cart-confirm-sheet{position:relative;width:100%;max-height:min(82dvh,760px);overflow:auto;overscroll-behavior:contain;background:#fff;color:#111;border-radius:28px 28px 0 0;padding:28px 24px calc(46px + env(safe-area-inset-bottom));box-shadow:0 -12px 44px rgba(0,0,0,.12);transform:translate3d(0,104%,0);transition:transform .26s cubic-bezier(.22,.8,.3,1);-webkit-overflow-scrolling:touch}'+
'#psi-cart-confirm.is-open .psi-cart-confirm-sheet{transform:translate3d(0,0,0)}'+
'.psi-cart-confirm-head{display:flex;align-items:center;gap:14px;padding-right:56px;min-height:44px}'+
'.psi-cart-confirm-check{display:grid;place-items:center;flex:0 0 25px;width:25px;height:25px;border-radius:50%;background:#0b8f55;color:#fff}'+
'.psi-cart-confirm-check svg{width:13px;height:13px}'+
'.psi-cart-confirm-title{margin:0;font-size:18.5px;line-height:1.18;font-weight:700;letter-spacing:-.022em}'+
'.psi-cart-confirm-close{position:absolute;top:22px;right:22px;display:grid;place-items:center;width:44px;height:44px;padding:0;border:0;border-radius:50%;background:transparent;color:#111;cursor:pointer;-webkit-tap-highlight-color:transparent}'+
'.psi-cart-confirm-close:before{content:"";position:absolute;width:39px;height:39px;border-radius:50%;background:#f5f5f5}'+
'.psi-cart-confirm-close svg{position:relative;z-index:1;width:19px;height:19px}'+
'.psi-cart-confirm-product{display:grid;grid-template-columns:112px minmax(0,1fr);gap:20px;margin-top:24px;align-items:start}'+
'.psi-cart-confirm-media{width:112px;height:132px;background:#f5f5f5;overflow:hidden}'+
'.psi-cart-confirm-media[hidden]{display:none}'+
'.psi-cart-confirm-media img{display:block;width:100%;height:100%;object-fit:contain}'+
'.psi-cart-confirm-product.is-box{grid-template-columns:150px minmax(0,1fr)}'+
'.psi-cart-confirm-product.is-box .psi-cart-confirm-media{width:150px;height:auto;aspect-ratio:1.92}'+
'.psi-cart-confirm-product.no-image{grid-template-columns:1fr}'+
'.psi-cart-confirm-info{min-width:0;padding-top:4px}'+
'.psi-cart-confirm-product-title{margin:0 0 8px;font-size:15.8px;line-height:1.28;font-weight:650;letter-spacing:-.015em}'+
'.psi-cart-confirm-meta{display:grid;gap:3px;margin:0 0 7px;color:#707070;font-size:14.1px;line-height:1.32}'+
'.psi-cart-confirm-price{margin:8px 0 0;font-size:15.8px;line-height:1.25;font-weight:500}'+
'.psi-cart-confirm-actions{display:grid;gap:12px;margin-top:28px}'+
'.psi-cart-confirm-action{display:flex;align-items:center;justify-content:center;min-height:60px;padding:12px 20px;border-radius:999px;text-decoration:none!important;font-size:17px;line-height:1.1;font-weight:700;letter-spacing:-.012em;-webkit-tap-highlight-color:transparent}'+
'.psi-cart-confirm-cart{border:1.5px solid #d0d0d0;background:#fff;color:#111}'+
'.psi-cart-confirm-checkout{border:1.5px solid #111;background:#111;color:#fff}'+
'button,a,summary,[role="button"],input[type="button"],input[type="submit"]{touch-action:manipulation}'+
'body.psi-cart-confirm-open{overflow:hidden}'+
'body.psi-cart-confirm-open .joinchat,body.psi-cart-confirm-open .joinchat__button,body.psi-cart-confirm-open .floating-wpp,body.psi-cart-confirm-open .wa__btn_popup,body.psi-cart-confirm-open [class*="whatsapp"],body.psi-cart-confirm-open [class*="WhatsApp"],body.psi-cart-confirm-open [id*="whatsapp"],body.psi-cart-confirm-open [id*="WhatsApp"],body.psi-cart-confirm-open a[href*="wa.me"],body.psi-cart-confirm-open a[href*="api.whatsapp.com"],body.psi-cart-confirm-open [aria-label*="WhatsApp"],body.psi-cart-confirm-open [aria-label*="whatsapp"],body.psi-cart-confirm-open [title*="WhatsApp"],body.psi-cart-confirm-open iframe[src*="whatsapp"]{opacity:0!important;visibility:hidden!important;pointer-events:none!important}'+
/* v526 — computer (da 901px): come Nike. Il riquadro e' attaccato sotto la
   testata bianca (--psi-confirm-top misurata dallo script) e ne continua il
   bianco: in alto dritto, in basso angoli arrotondati da 24px; si srotola
   dalla testata verso il basso. 428px, a 48px dal bordo destro, margini 24px,
   testi 16/24, due pulsanti da 60px uno sotto l'altro. Pagina dietro non
   oscurata. Se la testata non e' in vista (.is-floating) angoli tutti tondi. */
'@media (min-width:901px){'+
  '#psi-cart-confirm{align-items:flex-start;justify-content:flex-end;padding:var(--psi-confirm-top,24px) 48px 24px 24px}'+
  '#psi-cart-confirm .psi-cart-confirm-backdrop{background:transparent}'+
  '#psi-cart-confirm .psi-cart-confirm-sheet{width:428px;max-width:calc(100vw - 72px);max-height:calc(100dvh - var(--psi-confirm-top,24px) - 24px);border-radius:0 0 24px 24px;padding:24px;box-shadow:0 18px 32px -14px rgba(0,0,0,.18);transform:none;clip-path:inset(0 -48px 100% -48px);transition:clip-path .34s cubic-bezier(.22,.8,.3,1)}'+
  '#psi-cart-confirm.is-open .psi-cart-confirm-sheet{transform:none;clip-path:inset(0 -48px -48px -48px)}'+
  '#psi-cart-confirm.is-floating .psi-cart-confirm-sheet{border-radius:24px}'+
  '#psi-cart-confirm .psi-cart-confirm-head{gap:12px;min-height:24px;padding-right:40px}'+
  '#psi-cart-confirm .psi-cart-confirm-check{flex:0 0 24px;width:24px;height:24px;background:#007d48}'+
  '#psi-cart-confirm .psi-cart-confirm-title{font-size:16px;line-height:24px;font-weight:500;letter-spacing:0}'+
  '#psi-cart-confirm .psi-cart-confirm-close{top:18px;right:18px;width:36px;height:36px}'+
  '#psi-cart-confirm .psi-cart-confirm-close:before{width:36px;height:36px;background:transparent;transition:background-color .15s ease}'+
  '#psi-cart-confirm .psi-cart-confirm-close:hover:before{background:#e5e5e5}'+
  '#psi-cart-confirm .psi-cart-confirm-close svg{width:24px;height:24px;stroke-width:1.5}'+
  '#psi-cart-confirm .psi-cart-confirm-product{grid-template-columns:100px minmax(0,1fr);gap:16px;margin-top:24px}'+
  '#psi-cart-confirm .psi-cart-confirm-media{width:100px;height:100px}'+
  '#psi-cart-confirm .psi-cart-confirm-info{padding-top:0}'+
  '#psi-cart-confirm .psi-cart-confirm-product-title{margin:0;font-size:16px;line-height:24px;font-weight:500;letter-spacing:0}'+
  '#psi-cart-confirm .psi-cart-confirm-meta{gap:0;margin:0;color:#707072;font-size:16px;line-height:24px}'+
  '#psi-cart-confirm .psi-cart-confirm-price{margin:0;font-size:16px;line-height:24px;font-weight:500}'+
  '#psi-cart-confirm .psi-cart-confirm-actions{grid-template-columns:1fr;gap:12px;margin-top:24px}'+
  '#psi-cart-confirm .psi-cart-confirm-action{width:100%;height:60px;min-height:60px;border-radius:30px;font-size:16px;font-weight:500;letter-spacing:0}'+
  '#psi-cart-confirm .psi-cart-confirm-cart:hover{border-color:#111}'+
  '#psi-cart-confirm .psi-cart-confirm-checkout:hover{background:#707072;border-color:#707072}'+
'}'+
'@media (max-width:420px){.psi-cart-confirm-sheet{padding-left:20px;padding-right:20px;padding-bottom:calc(52px + env(safe-area-inset-bottom))}.psi-cart-confirm-title{font-size:17.6px}.psi-cart-confirm-product{grid-template-columns:96px minmax(0,1fr);gap:17px}.psi-cart-confirm-media{width:96px;height:116px}.psi-cart-confirm-product.is-box{grid-template-columns:128px minmax(0,1fr)}.psi-cart-confirm-product.is-box .psi-cart-confirm-media{width:128px;height:auto}.psi-cart-confirm-product-title,.psi-cart-confirm-price{font-size:15px}.psi-cart-confirm-meta{font-size:14.1px}.psi-cart-confirm-action{font-size:17px}}'+
'@media (prefers-reduced-motion:reduce){.psi-cart-confirm-backdrop,.psi-cart-confirm-sheet{transition-duration:.01ms}}';
document.head.appendChild(style);

/* PSI v410 - nessun ritardo artificiale sui link interni. theme.js applica
   una transizione di uscita da 240 ms salvo data-no-transition: lo impostiamo
   in capture prima che il gestore globale possa bloccare la navigazione. */
document.addEventListener('click',function(e){
  var a=e.target&&e.target.closest?e.target.closest('a[href]'):null;
  if(!a)return;
  var href=a.getAttribute('href')||'';
  if(!href||href.charAt(0)==='#'||href.indexOf('javascript:')===0)return;
  if((a.target&&a.target!=='_self')||a.hasAttribute('download'))return;
  try{
    var url=new URL(a.href,location.href);
    if(url.origin!==location.origin)return;
    a.setAttribute('data-no-transition','')
  }catch(err){}
},true);

var shell=document.createElement('div');
shell.id='psi-cart-confirm';
shell.setAttribute('aria-hidden','true');
shell.innerHTML=
'<div class="psi-cart-confirm-backdrop" data-psi-cart-close></div>'+
'<section class="psi-cart-confirm-sheet" role="dialog" aria-modal="true" aria-labelledby="psi-cart-confirm-title">'+
  '<div class="psi-cart-confirm-head">'+
    '<span class="psi-cart-confirm-check" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.7" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 4.2 4.2L19 6.5"/></svg></span>'+
    '<h2 class="psi-cart-confirm-title" id="psi-cart-confirm-title">Aggiunto al carrello</h2>'+
  '</div>'+
  '<button class="psi-cart-confirm-close" type="button" aria-label="Chiudi" data-psi-cart-close><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button>'+
  '<div class="psi-cart-confirm-product">'+
    '<div class="psi-cart-confirm-media"><img alt="" width="224" height="264"></div>'+
    '<div class="psi-cart-confirm-info">'+
      '<p class="psi-cart-confirm-product-title"></p>'+
      '<div class="psi-cart-confirm-meta"></div>'+
      '<p class="psi-cart-confirm-price"></p>'+
    '</div>'+
  '</div>'+
  '<div class="psi-cart-confirm-actions">'+
    '<a class="psi-cart-confirm-action psi-cart-confirm-cart" data-no-transition href="'+root+'cart">Visualizza carrello</a>'+
    '<a class="psi-cart-confirm-action psi-cart-confirm-checkout" data-no-transition href="/checkout">Pagamento</a>'+
  '</div>'+
'</section>';
document.body.appendChild(shell);

var media=shell.querySelector('.psi-cart-confirm-media');
var img=media.querySelector('img');
var product=shell.querySelector('.psi-cart-confirm-product');
var productTitle=shell.querySelector('.psi-cart-confirm-product-title');
var meta=shell.querySelector('.psi-cart-confirm-meta');
var price=shell.querySelector('.psi-cart-confirm-price');
var cartLink=shell.querySelector('.psi-cart-confirm-cart');
var closeButton=shell.querySelector('.psi-cart-confirm-close');

function clearPending(){
  if(pendingTimer){clearTimeout(pendingTimer);pendingTimer=null}
  pendingAdd=null
}
function markPending(btn){
  var variantId='';
  if(btn.dataset&&btn.dataset.variantId)variantId=btn.dataset.variantId;
  if(!variantId&&btn.id==='add-to-cart-btn'){
    var selected=document.getElementById('selected-variant-id');
    if(selected)variantId=selected.value
  }
  if(!variantId){
    var form=btn.closest&&btn.closest('form');
    var idInput=form&&form.querySelector('[name="id"]');
    if(idInput)variantId=idInput.value
  }
  pendingAdd={
    variantId:String(variantId||''),
    title:(btn.dataset&&btn.dataset.productTitle)||'',
    trigger:btn
  };
  if(pendingTimer)clearTimeout(pendingTimer);
  pendingTimer=setTimeout(clearPending,8000)
}
document.addEventListener('click',function(e){
  var target=e.target&&e.target.closest?e.target:null;
  if(!target)return;
  if(target.closest('#cart-toggle')){clearPending();return}
  var btn=target.closest('.btn-add-to-cart[data-variant-id],#add-to-cart-btn,[data-add-cart],button[name="add"],input[name="add"]');
  /* il BOX chiama l'avviso da se' con il riepilogo del box: qui non va segnato */
  if(!btn||btn.closest('#cart-drawer')||btn.closest('[data-psi-box]')||btn.id==='buy-now-btn'||btn.closest('[data-psi-buy]'))return;
  if(btn.disabled||btn.classList.contains('loading'))return;
  markPending(btn)
},true);

function hideLegacyNotification(){
  var note=document.getElementById('cart-notification');
  if(note){note.classList.remove('show');note.textContent=''}
}
function formatPrice(cents,currency){
  try{return new Intl.NumberFormat(document.documentElement.lang||'it-IT',{style:'currency',currency:currency||'EUR'}).format((Number(cents)||0)/100)}
  catch(e){return money(cents)}
}
function optionLines(item){
  var lines=[];
  if(item&&Array.isArray(item.options_with_values)){
    item.options_with_values.forEach(function(opt){
      if(!opt||!opt.value||opt.value==='Default Title')return;
      lines.push((opt.name?opt.name+' ':'')+opt.value)
    })
  }else if(item&&item.variant_title&&item.variant_title!=='Default Title'){
    lines.push(item.variant_title)
  }
  if(item&&Number(item.quantity)>1)lines.push('Quantità '+item.quantity);
  return lines
}
function setImage(url,alt){
  if(url){
    img.loading='eager';
    img.decoding='async';
    img.setAttribute('fetchpriority','high');
    img.src=url;
    img.alt=alt||'';
    media.hidden=false;
    product.classList.remove('no-image')
  }else{
    img.removeAttribute('src');
    img.alt='';
    media.hidden=true;
    product.classList.add('no-image')
  }
}
function setMeta(lines){
  meta.textContent='';
  lines.forEach(function(line){
    var row=document.createElement('span');
    row.textContent=line;
    meta.appendChild(row)
  });
  meta.hidden=!meta.childNodes.length
}
function renderConfirmation(cart,ctx){
  var items=cart&&Array.isArray(cart.items)?cart.items:[];
  product.classList.toggle('is-box',!!ctx.group);
  if(ctx.group){
    /* BOX: tutte le righe aggiunte insieme, riconosciute dal gruppo */
    var rows=items.filter(function(row){return row.properties&&row.properties._psi_box_group===ctx.group});
    var pezzi=rows.reduce(function(t,r){return t+Number(r.quantity||0)},0);
    var totale=rows.reduce(function(t,r){return t+Number(r.final_line_price||0)},0);
    productTitle.textContent=ctx.title||'Box';
    setImage(ctx.image||(rows[0]&&rows[0].image)||'',ctx.title);
    var lines=(ctx.meta||[]).slice();
    if(rows.length)lines.push(rows.length+(rows.length===1?' articolo':' articoli')+' · '+pezzi+(pezzi===1?' pezzo':' pezzi'));
    setMeta(lines);
    if(rows.length){price.textContent=formatPrice(totale,cart&&cart.currency);price.hidden=false}
    else{price.textContent='';price.hidden=true}
  }else{
    var item=null;
    if(ctx.variantId){
      item=items.find(function(row){return String(row.variant_id)===ctx.variantId})||null
    }else if(items.length===1){
      item=items[0]
    }
    var title=(item&&(item.product_title||item.title))||ctx.title||'Prodotto aggiunto al carrello';
    productTitle.textContent=title;
    setImage(item?((item.featured_image&&item.featured_image.url)||item.image||''):'',title);
    setMeta(optionLines(item));
    if(item&&typeof item.final_price!=='undefined'){
      price.textContent=formatPrice(item.final_price,cart&&cart.currency);
      price.hidden=false
    }else{
      price.textContent='';
      price.hidden=true
    }
  }
  /* ctx.cartHref: dove porta "Visualizza carrello" quando la pagina non ha il
     carrello a scomparsa (pagina BOX: Grandi Forniture con il carrello aperto) */
  cartLink.setAttribute('href',ctx.cartHref||root+'cart');
  var count=cart&&typeof cart.item_count!=='undefined'?Number(cart.item_count):parseInt((document.getElementById('cart-count')||{}).textContent,10);
  cartLink.textContent='Visualizza carrello'+(isFinite(count)&&count>0?' ('+count+')':'')
}
function waitForConfirmationImage(){
  if(media.hidden||!img.getAttribute('src'))return Promise.resolve();
  function decodeImage(){
    if(typeof img.decode!=='function')return Promise.resolve();
    return img.decode().catch(function(){})
  }
  if(img.complete){
    if(img.naturalWidth>0)return decodeImage();
    media.hidden=true;
    product.classList.add('no-image');
    return Promise.resolve()
  }
  return new Promise(function(resolve){
    var settled=false;
    function finish(ok){
      if(settled)return;
      settled=true;
      img.removeEventListener('load',onLoad);
      img.removeEventListener('error',onError);
      if(!ok){
        media.hidden=true;
        product.classList.add('no-image');
        resolve();
        return
      }
      decodeImage().then(resolve)
    }
    function onLoad(){finish(true)}
    function onError(){finish(false)}
    img.addEventListener('load',onLoad,{once:true});
    img.addEventListener('error',onError,{once:true})
  })
}
/* computer: il riquadro sta a filo sotto la testata, misurata ogni volta che si
   apre (l'altezza cambia con la larghezza). Senza testata (pagina BOX) 24px. */
function placeSheet(){
  var top=24,attached=false;
  var header=document.getElementById('site-header');
  if(header){
    var r=header.getBoundingClientRect();
    if(r.bottom>0&&r.bottom<window.innerHeight/2){top=Math.round(r.bottom);attached=true}
  }
  shell.style.setProperty('--psi-confirm-top',top+'px');
  shell.classList.toggle('is-floating',!attached)
}
function openConfirmation(ctx){
  placeSheet();
  if(shell.classList.contains('is-open'))return;
  previousFocus=ctx.trigger||document.activeElement;
  shell.setAttribute('aria-hidden','false');
  shell.classList.add('is-open');
  document.body.classList.add('psi-cart-confirm-open');
  try{closeButton.focus({preventScroll:true})}catch(e){closeButton.focus()}
}
function showConfirmation(ctx){
  currentCtx=ctx;
  var request=++confirmationRequest;
  fetch(root+'cart.js',{headers:{'Accept':'application/json'},credentials:'same-origin'})
    .then(function(r){if(!r.ok)throw new Error('cart');return r.json()})
    .then(function(cart){
      if(request!==confirmationRequest)return;
      renderConfirmation(cart,ctx);
      return waitForConfirmationImage().then(function(){
        if(request!==confirmationRequest)return;
        openConfirmation(ctx)
      })
    })
    .catch(function(){
      if(request!==confirmationRequest)return;
      renderConfirmation(null,ctx);
      openConfirmation(ctx)
    })
}
function closeConfirmation(){
  if(!shell.classList.contains('is-open'))return;
  shell.classList.remove('is-open');
  shell.setAttribute('aria-hidden','true');
  document.body.classList.remove('psi-cart-confirm-open');
  if(previousFocus&&typeof previousFocus.focus==='function'){
    try{previousFocus.focus({preventScroll:true})}catch(e){}
  }
  previousFocus=null;
  /* ctx.onClose: chi ha aperto l'avviso decide cosa succede alla chiusura (il BOX
     esce dal configuratore) */
  var ctx=currentCtx;currentCtx=null;
  if(ctx&&typeof ctx.onClose==='function')ctx.onClose()
}
shell.addEventListener('click',function(e){
  if(e.target.closest&&e.target.closest('[data-psi-cart-close]')){e.preventDefault();closeConfirmation()}
});
document.addEventListener('keydown',function(e){
  if(!shell.classList.contains('is-open'))return;
  if(e.key==='Escape'){e.preventDefault();closeConfirmation();return}
  if(e.key!=='Tab')return;
  var focusable=Array.prototype.slice.call(shell.querySelectorAll('button:not([disabled]),a[href]')).filter(function(el){return el.offsetParent!==null});
  if(!focusable.length)return;
  var first=focusable[0],last=focusable[focusable.length-1];
  if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}
  else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}
});

/* chi aggiunge al carrello da codice (BOX, completa il look...) chiama questo */
window.psiCartConfirm={
  show:function(ctx){
    ctx=ctx||{};
    if(ctx.variantId!=null)ctx.variantId=String(ctx.variantId);
    clearPending();
    closeDrawer();
    hideLegacyNotification();
    showConfirmation(ctx)
  },
  close:closeConfirmation
};

/* v514 — arrivo con #carrello (dalla pagina BOX): si apre subito il carrello a
   scomparsa, poi il segno viene tolto dall'indirizzo. */
if(drawer&&location.hash==='#carrello'){
  try{history.replaceState(null,'',location.pathname+location.search)}catch(e){}
  /* appena la pagina e' pronta (non si aspettano le immagini): dopo tutti i
     DOMContentLoaded, cosi' il pulsante del carrello ha gia' il suo gestore */
  var apriCarrello=function(){setTimeout(function(){var t=document.getElementById('cart-toggle');if(t)t.click()},60)};
  if(document.readyState!=='loading')apriCarrello();else document.addEventListener('DOMContentLoaded',apriCarrello,{once:true})
}
if(drawer){
  var openObserver=new MutationObserver(function(){
    if(!pendingAdd)return;
    if(drawer.classList.contains('open')||drawer.getAttribute('aria-hidden')==='false'){
      var ctx=pendingAdd;
      clearPending();
      closeDrawer();
      hideLegacyNotification();
      showConfirmation(ctx)
    }
  });
  openObserver.observe(drawer,{attributes:true,attributeFilter:['class','aria-hidden']});
}
}());

;
/* psi-cart-nike-v410.js */
(function(){
'use strict';
var drawer=document.getElementById('cart-drawer');if(!drawer)return;
var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
var cache=Object.create(null);
function isOpen(){return drawer.classList.contains('open')||drawer.getAttribute('aria-hidden')==='false'}
function close(){drawer.setAttribute('aria-hidden','true');drawer.classList.remove('open');var o=document.getElementById('cart-overlay');if(o)o.classList.remove('visible');document.body.classList.remove('cart-open')}
function currency(){return (window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR'}
function money(cents){try{return new Intl.NumberFormat(document.documentElement.lang||'it-IT',{style:'currency',currency:currency()}).format((Number(cents)||0)/100)}catch(e){return '€ '+((Number(cents)||0)/100).toFixed(2)}}
function image(p){var v=p&&p.featured_image;if(v&&typeof v==='object')v=v.url||v.src||'';if(typeof v==='string'&&v)return v;if(p&&Array.isArray(p.images)&&p.images.length){v=p.images[0];if(v&&typeof v==='object')return v.url||v.src||'';if(typeof v==='string')return v}return ''}
function sized(url){if(!url)return '';try{var u=new URL(url,location.href);if(u.hostname.indexOf('cdn.shopify.com')!==-1)u.searchParams.set('width','600');return u.href}catch(e){return url}}
function href(p){if(p&&p.url)return p.url;if(p&&p.handle)return root+'products/'+encodeURIComponent(p.handle);return '#'}
function inCart(){var ids=Object.create(null);drawer.querySelectorAll('.cart-item[data-product-id]').forEach(function(r){ids[String(r.getAttribute('data-product-id')||'')]=1});return ids}
function card(p){var a,el,c=document.createElement('article');c.className='psi-cart-rec-card';var url=href(p);a=document.createElement('a');a.className='psi-cart-rec-media';a.href=url;a.setAttribute('data-no-transition','');var src=image(p);if(src){el=document.createElement('img');el.src=sized(src);el.alt=p.title||'';el.loading='lazy';el.decoding='async';el.width=600;el.height=600;a.appendChild(el)}c.appendChild(a);a=document.createElement('a');a.className='psi-cart-rec-title';a.href=url;a.setAttribute('data-no-transition','');a.textContent=p.title||'Prodotto';c.appendChild(a);el=document.createElement('span');el.className='psi-cart-rec-type';el.textContent=p.type||p.vendor||'';c.appendChild(el);var pr=document.createElement('p');pr.className='psi-cart-rec-price';el=document.createElement('span');el.textContent=money(p.price);pr.appendChild(el);var old=Number(p.compare_at_price)||0,now=Number(p.price)||0;if(old>now){el=document.createElement('span');el.className='psi-cart-rec-compare';el.textContent=money(old);pr.appendChild(el)}c.appendChild(pr);return c}
function render(section,products){if(!section||!document.documentElement.contains(section))return;var track=section.querySelector('[data-psi-cart-rec-track]');if(!track)return;var ids=inCart(),list=(Array.isArray(products)?products:[]).filter(function(p){return p&&p.available!==false&&!ids[String(p.id)]}).slice(0,8);track.textContent='';track.setAttribute('aria-busy','false');section.dataset.loaded='1';if(!list.length){section.hidden=true;return}list.forEach(function(p){track.appendChild(card(p))});section.hidden=false}
function load(){if(!isOpen())return;var section=drawer.querySelector('[data-psi-cart-recommendations]');if(!section)return;var id=String(section.getAttribute('data-product-id')||'');if(!id){section.hidden=true;return}if(section.dataset.loaded==='1')return;if(cache[id]){render(section,cache[id]);return}if(section.dataset.loading==='1')return;section.dataset.loading='1';fetch(root+'recommendations/products.json?product_id='+encodeURIComponent(id)+'&limit=8&intent=related',{headers:{Accept:'application/json'},credentials:'same-origin'}).then(function(r){if(!r.ok)throw new Error('rec');return r.json()}).then(function(d){cache[id]=d&&Array.isArray(d.products)?d.products:[];render(section,cache[id])}).catch(function(){if(document.documentElement.contains(section))section.hidden=true}).finally(function(){if(document.documentElement.contains(section))section.dataset.loading=''})}
document.addEventListener('click',function(e){var a=e.target&&e.target.closest?e.target.closest('.psi-cart-confirm-cart'):null;if(!a)return;e.preventDefault();e.stopImmediatePropagation();var x=document.querySelector('#psi-cart-confirm [data-psi-cart-close]');if(x)x.click();var t=document.getElementById('cart-toggle');if(t)t.click()},true);
drawer.addEventListener('click',function(e){var b=e.target&&e.target.closest?e.target.closest('[data-psi-rec-prev],[data-psi-rec-next]'):null;if(!b)return;var section=b.closest('[data-psi-cart-recommendations]'),track=section&&section.querySelector('[data-psi-cart-rec-track]');if(!track)return;e.preventDefault();var dir=b.hasAttribute('data-psi-rec-prev')?-1:1,dist=Math.max(260,Math.round(track.clientWidth*.82));try{track.scrollBy({left:dir*dist,behavior:'smooth'})}catch(err){track.scrollLeft+=dir*dist}});
document.addEventListener('keydown',function(e){if(e.key!=='Escape'||!isOpen())return;e.preventDefault();close();var t=document.getElementById('cart-toggle');if(t&&t.focus)try{t.focus({preventScroll:true})}catch(err){t.focus()}});
new MutationObserver(function(){if(isOpen())load()}).observe(drawer,{attributes:true,attributeFilter:['class','aria-hidden']});
var body=document.getElementById('cart-drawer-body');if(body)new MutationObserver(function(){if(isOpen())requestAnimationFrame(load)}).observe(body,{childList:true});
}());

;
/* psi-cart-nike-v411.js */
(function(){
'use strict';
var drawer=document.getElementById('cart-drawer');if(!drawer)return;
var body=document.getElementById('cart-drawer-body');
var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
var cfg=window.PSI_CART_V411||{};
var baseShipping=Number(cfg.shippingCents);if(!isFinite(baseShipping))baseShipping=499;
var freeThreshold=Number(cfg.freeShippingThreshold)||0;
var currency=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR';
function money(cents){try{return new Intl.NumberFormat(document.documentElement.lang||'it-IT',{style:'currency',currency:currency}).format((Number(cents)||0)/100)}catch(e){return '€ '+((Number(cents)||0)/100).toFixed(2).replace('.',',')}}
function parseMoney(text){var s=String(text||'').replace(/\s/g,'').replace(/[^0-9,.-]/g,'');if(!s)return 0;if(s.indexOf(',')!==-1)s=s.replace(/\./g,'').replace(',','.');var n=parseFloat(s);return isFinite(n)?Math.round(n*100):0}
function qtyValue(el){return Math.max(0,parseInt(el&&el.value,10)||0)}
function rows(){return Array.prototype.slice.call(drawer.querySelectorAll('.cart-item:not(.is-removing)'))}
function localState(){var subtotal=0,count=0;rows().forEach(function(row){var q=row.querySelector('.qty-num'),p=row.querySelector('.cart-item-price');if(!q||!p)return;var qty=qtyValue(q),unit=parseInt(p.dataset.unitPrice,10)||0;count+=qty;subtotal+=unit*qty});return{subtotal:subtotal,count:count}}
function shippingFor(subtotal,count){if(count<=0)return 0;if(freeThreshold>0&&subtotal>=freeThreshold)return 0;return baseShipping}
function setText(selector,value){var el=drawer.querySelector(selector);if(el&&el.textContent!==value)el.textContent=value}
function isOpen(){return drawer.classList.contains('open')||drawer.getAttribute('aria-hidden')==='false'}

/* V411 - barra spedizione gratuita sotto il riepilogo iniziale del carrello. */
function ensureShippingProgress(){
  var bar=drawer.querySelector('.psi-cart-shipping-progress');
  if(bar)return bar;
  var hero=drawer.querySelector('.psi-cart-hero');
  if(!hero)return null;
  bar=document.createElement('section');
  bar.className='psi-cart-shipping-progress';
  bar.setAttribute('aria-label','Stato spedizione gratuita');
  bar.innerHTML='<p class="psi-cart-shipping-progress-text" aria-live="polite"></p><div class="psi-cart-shipping-progress-track" aria-hidden="true"><span class="psi-cart-shipping-progress-fill"></span></div>';
  hero.insertAdjacentElement('afterend',bar);
  return bar
}
function renderShippingProgress(subtotal,count){
  var bar=drawer.querySelector('.psi-cart-shipping-progress');
  if(freeThreshold<=0||count<=0){if(bar)bar.remove();return}
  if(!bar)bar=ensureShippingProgress();
  if(!bar)return;
  var done=subtotal>=freeThreshold;
  var remaining=Math.max(0,freeThreshold-subtotal);
  var pct=Math.max(0,Math.min(100,(subtotal/freeThreshold)*100));
  var text=bar.querySelector('.psi-cart-shipping-progress-text');
  var fill=bar.querySelector('.psi-cart-shipping-progress-fill');
  bar.classList.toggle('is-done',done);
  if(fill)fill.style.width=pct.toFixed(2)+'%';
  if(text){
    text.textContent='';
    if(done){
      text.textContent='✓ Hai ottenuto la spedizione gratuita';
    }else{
      text.appendChild(document.createTextNode('Ti mancano '));
      var amount=document.createElement('strong');
      amount.textContent=money(remaining);
      text.appendChild(amount);
      text.appendChild(document.createTextNode(' per la spedizione gratuita'))
    }
  }
}

function renderTotals(subtotal,count,writeSubtotal){var shipping=shippingFor(subtotal,count),total=subtotal+shipping;if(writeSubtotal)setText('#cart-subtotal',money(subtotal));setText('[data-psi-cart-shipping]',shipping===0?'Gratis':money(shipping));setText('[data-psi-cart-total]',money(total));setText('[data-psi-cart-hero-total]',money(total));setText('[data-psi-cart-item-label]',count===1?'articolo':'articoli');var c=drawer.querySelector('#cart-count-drawer');if(c&&String(c.textContent).trim()!==String(count))c.textContent=String(count);var hc=document.getElementById('cart-count');if(hc&&String(hc.textContent).trim()!==String(count)){hc.textContent=String(count);hc.classList.toggle('hidden',count===0)}renderShippingProgress(subtotal,count)}
function renderLocal(){var s=localState();renderTotals(s.subtotal,s.count,true)}
function renderFromSubtotal(){var sub=drawer.querySelector('#cart-subtotal');if(!sub)return renderLocal();var s=localState();renderTotals(parseMoney(sub.textContent),s.count,false)}
function syncQtyActions(){drawer.querySelectorAll('.psi-cart-qty-dec').forEach(function(btn){var wrap=btn.closest('.cart-item-qty'),input=wrap&&wrap.querySelector('.qty-num'),q=qtyValue(input),remove=q<=1;btn.dataset.action=remove?'remove':'decrease';btn.setAttribute('aria-label',remove?'Rimuovi articolo':'Diminuisci quantità')})}
function micro(fn){if(typeof queueMicrotask==='function')queueMicrotask(fn);else Promise.resolve().then(fn)}

/* V411 - opzioni variante separate: Taglia e Colore su righe autonome. */
var variantRequest=0,variantQueued=false;
function optionKind(name){
  var n=String(name||'').toLowerCase();
  if(n.indexOf('taglia')!==-1||n.indexOf('size')!==-1||n.indexOf('misura')!==-1)return 'size';
  if(n.indexOf('colore')!==-1||n.indexOf('color')!==-1)return 'color';
  return ''
}
function variantRows(item){
  var opts=item&&Array.isArray(item.options_with_values)?item.options_with_values:[];
  var size=null,color=null,other=[];
  opts.forEach(function(opt){
    if(!opt||!opt.value||opt.value==='Default Title')return;
    var kind=optionKind(opt.name);
    if(kind==='size'&&!size)size=opt;
    else if(kind==='color'&&!color)color=opt;
    else other.push(opt)
  });
  var out=[];
  if(size)out.push(['Taglia',size.value]);
  if(color)out.push(['Colore',color.value]);
  other.forEach(function(opt){out.push([opt.name||'Opzione',opt.value])});
  return out
}
function renderVariantOptions(cart){
  var map=Object.create(null);
  var items=cart&&Array.isArray(cart.items)?cart.items:[];
  items.forEach(function(item){if(item&&item.key)map[String(item.key)]=item});
  rows().forEach(function(row){
    var box=row.querySelector('.cart-item-variant');
    if(!box)return;
    var item=map[String(row.getAttribute('data-key')||'')];
    if(!item)return;
    var lines=variantRows(item);
    if(!lines.length)return;
    box.textContent='';
    lines.forEach(function(line){
      var r=document.createElement('div');r.className='psi-cart-variant-row';
      var label=document.createElement('span');label.className='psi-cart-variant-label';label.textContent=line[0];
      var value=document.createElement('span');value.className='psi-cart-variant-value';value.textContent=line[1];
      r.appendChild(label);r.appendChild(value);box.appendChild(r)
    })
  })
}
function loadVariantOptions(){
  if(!isOpen())return;
  var request=++variantRequest;
  fetch(root+'cart.js',{headers:{Accept:'application/json'},credentials:'same-origin',cache:'no-store'})
    .then(function(r){if(!r.ok)throw new Error('cart');return r.json()})
    .then(function(cart){if(request!==variantRequest||!isOpen())return;renderVariantOptions(cart)})
    .catch(function(){})
}
function scheduleVariantOptions(){
  if(variantQueued)return;
  variantQueued=true;
  micro(function(){variantQueued=false;loadVariantOptions()})
}

drawer.addEventListener('click',function(e){var btn=e.target&&e.target.closest?e.target.closest('.qty-btn'):null;if(!btn)return;micro(function(){syncQtyActions();renderLocal()})});
drawer.addEventListener('change',function(e){if(!e.target.classList||!e.target.classList.contains('qty-num'))return;micro(function(){syncQtyActions();renderLocal()})});
drawer.addEventListener('keyup',function(e){if(e.key!=='Enter'||!e.target.classList||!e.target.classList.contains('qty-num'))return;micro(function(){syncQtyActions();renderLocal()})});
drawer.addEventListener('submit',function(e){var form=e.target&&e.target.closest?e.target.closest('[data-psi-cart-search]'):null;if(!form)return;var input=form.querySelector('.psi-cart-search-input');if(!input||!input.value.trim()){e.preventDefault();if(input)input.focus()}});

var observedSubtotal=null;
var subtotalObserver=new MutationObserver(function(){micro(renderFromSubtotal)});
function attachSubtotalObserver(){var sub=drawer.querySelector('#cart-subtotal');if(sub===observedSubtotal)return;subtotalObserver.disconnect();observedSubtotal=sub;if(sub)subtotalObserver.observe(sub,{childList:true,characterData:true,subtree:true})}
if(body)new MutationObserver(function(){micro(function(){attachSubtotalObserver();syncQtyActions();renderFromSubtotal();scheduleVariantOptions()})}).observe(body,{childList:true});
new MutationObserver(function(){if(isOpen()){renderFromSubtotal();scheduleVariantOptions()}}).observe(drawer,{attributes:true,attributeFilter:['class','aria-hidden']});
attachSubtotalObserver();syncQtyActions();renderFromSubtotal();if(isOpen())scheduleVariantOptions();
}());

;
/* psi-cart-nike-v411-refine.js */
(function(){
'use strict';
var drawer=document.getElementById('cart-drawer');
var header=document.getElementById('site-header');
if(!drawer||!header)return;

function isOpen(){
  return drawer.classList.contains('open')||drawer.getAttribute('aria-hidden')==='false';
}
function setHeaderHeight(){
  var h=Math.ceil(header.getBoundingClientRect().height||0);
  if(h>0)document.documentElement.style.setProperty('--psi-cart-site-header-h',h+'px');
}
function syncChrome(){
  if(isOpen()){
    setHeaderHeight();
    document.body.classList.add('psi-cart-v411-open');
  }else{
    document.body.classList.remove('psi-cart-v411-open');
    document.documentElement.style.removeProperty('--psi-cart-site-header-h');
  }
}
function openCart(toggle){
  var overlay=document.getElementById('cart-overlay');
  drawer.setAttribute('aria-hidden','false');
  drawer.classList.add('open');
  if(overlay)overlay.classList.add('visible');
  document.body.classList.add('cart-open');
  if(toggle)toggle.setAttribute('aria-expanded','true');
}
function closeCart(){
  var close=drawer.querySelector('#cart-close');
  if(close)close.click();
}
function clearPointerFocus(toggle,event){
  if(!toggle||!toggle.blur||!event||event.detail===0)return;
  setTimeout(function(){if(document.activeElement===toggle)toggle.blur();},0);
}

/* v459 - restituisce il feedback tattile visivo senza usare :hover.
   Su touch il grigio resta solo per un istante e poi viene rimosso sempre. */
var cartToggle=document.getElementById('cart-toggle');
var cartTapTimer=null;
function endCartTap(){
  if(!cartToggle)return;
  cartToggle.style.removeProperty('background-color');
  if(cartTapTimer){clearTimeout(cartTapTimer);cartTapTimer=null;}
}
function startCartTap(event){
  if(!cartToggle||!window.matchMedia||!window.matchMedia('(max-width:900px) and (hover:none)').matches)return;
  if(event&&event.pointerType==='mouse')return;
  cartToggle.style.setProperty('background-color','#f4f4f4','important');
  if(cartTapTimer)clearTimeout(cartTapTimer);
  cartTapTimer=setTimeout(endCartTap,160);
}
if(cartToggle){
  if(window.PointerEvent){
    cartToggle.addEventListener('pointerdown',startCartTap,{passive:true});
    cartToggle.addEventListener('pointercancel',endCartTap,{passive:true});
  }else{
    cartToggle.addEventListener('touchstart',startCartTap,{passive:true});
    cartToggle.addEventListener('touchcancel',endCartTap,{passive:true});
  }
}

new MutationObserver(syncChrome).observe(drawer,{attributes:true,attributeFilter:['class','aria-hidden']});
window.addEventListener('resize',function(){if(isOpen())setHeaderHeight()},{passive:true});
window.addEventListener('orientationchange',function(){if(isOpen())setHeaderHeight()},{passive:true});
if(window.ResizeObserver){
  new ResizeObserver(function(){if(isOpen())setHeaderHeight()}).observe(header);
}

document.addEventListener('click',function(e){
  if(!e.target||!e.target.closest)return;

  var toggle=e.target.closest('#site-header #cart-toggle');
  if(toggle){
    clearPointerFocus(toggle,e);
    if(isOpen()){
      e.preventDefault();
      e.stopImmediatePropagation();
      closeCart();
    }else{
      /* Apertura immediata in capture: non dipende dal listener piu' pesante
         di theme.js. Il suo click successivo resta consentito ed e' idempotente. */
      openCart(toggle);
    }
    return;
  }

  if(!isOpen())return;
  var headerAction=e.target.closest('#site-header a,#site-header #search-toggle,#site-header #psi-burger');
  if(headerAction)closeCart();
},true);

syncChrome();
}());

/* v460 - riporta Svuota carrello nel footer senza duplicare la logica Ajax gia presente. */
(function(){
'use strict';

var drawer=document.getElementById('cart-drawer');
var footer=document.getElementById('cart-drawer-footer');
if(!drawer||!footer)return;

function syncFooterActions(){
  var inner=footer.querySelector('.psi-cart-footer-inner');
  var quote=inner&&inner.querySelector('#psi-cart-quote');
  if(!inner||!quote)return;

  var row=inner.querySelector('.psi-cart-secondary-actions');
  if(!row){
    row=document.createElement('div');
    row.className='psi-cart-secondary-actions';
    quote.parentNode.insertBefore(row,quote);
  }

  if(quote.parentNode!==row)row.appendChild(quote);

  var clear=row.querySelector('[data-psi-cart-clear-footer]');
  if(!clear){
    clear=document.createElement('button');
    clear.type='button';
    clear.className='psi-cart-clear-footer';
    clear.setAttribute('data-psi-cart-clear-footer','');
    clear.setAttribute('aria-label','Svuota carrello');
    clear.textContent='Svuota carrello';
    row.appendChild(clear);
  }
}

drawer.addEventListener('click',function(event){
  if(!event.target||!event.target.closest)return;
  var clear=event.target.closest('[data-psi-cart-clear-footer]');
  if(!clear)return;

  event.preventDefault();
  if(clear.disabled)return;

  var source=document.getElementById('cart-clear');
  if(!source||source.hidden||source.disabled)return;

  clear.disabled=true;
  clear.setAttribute('aria-busy','true');
  source.click();
});

syncFooterActions();
new MutationObserver(function(){
  window.requestAnimationFrame(syncFooterActions);
}).observe(footer,{childList:true,subtree:true});
}());

;